import React from "react";
import ReactEChart from "echarts-for-react";
import { ContainerPanel } from "@components/organisms/container-panel/container-panel";
import styles from "./dashboard-graph-panel-content.module.scss";
import { useI18N } from "@src/language/language-context";

interface DashboardPanelProps {
  title: string;
  graphOptionsObject: any | undefined | null;
}

const cssClassName = "dashboard-graph-panel-content";

export const DashboardGraphPanelContent = ({
  title,
  graphOptionsObject,
}: DashboardPanelProps) => {
  const i18n = useI18N();

  const texts = {
    noDataMessage: i18n("modules.dashboardGraphPanelContent.noDataMessage"),
  };

  return (
    <div className={styles[cssClassName]}>
      <ContainerPanel>
        <div className={styles[`${cssClassName}__title-wrapper`]}>
          <p className={styles[`${cssClassName}__title`]}>{title}</p>
        </div>
        {graphOptionsObject === null ? (
          <div className={styles[`${cssClassName}__no-data-message-wrapper`]}>
            {texts.noDataMessage}
          </div>
        ) : (
          <div className={styles[`${cssClassName}__graph-wrapper`]}>
            <ReactEChart
              style={{
                width: "100%",
                height: "100%",
              }}
              option={graphOptionsObject}
            />
          </div>
        )}
      </ContainerPanel>
    </div>
  );
};
